module.exports = __webpack_public_path__ + "media/components/riskregister/icons/facilities-dee926122e8872226cf344f42a75711d.png";